const getter = (name) => (target, property, _receiver) => {
  if (Object.hasOwn(target, property)) {
    return target[property]
  }
  throw new Error(`Enum ${name} has no '${property}' property`)
}

const setter = (name) => (_target, property, _receiver) => {
  throw new Error(`Cannot update the '${property}' property of enum ${name}`)
}

export const createEnum = (values, name = 'enum') => {
  return Object.freeze(
    new Proxy(values, {
      get: getter(name),
      set: setter(name)
    })
  )
}
